<template>
    <v-content>
        <v-container fluid grid-list-lg>
            <v-layout row wrap>
                    <v-flex xs12>
                        <v-card class="white--text">
                            <v-card-title primary-title>
                                <div>
                                    <h3 class="headline mb-0">Rapport abonnementen
                                       </h3>
                                    <div>{{subscriptions.length}} abonnementen</div>
                                </div>
                            </v-card-title>
                        </v-card>
                    </v-flex>
            </v-layout>
        </v-container>
        <v-container fluid grid-list-lg v-if="items">
            <v-data-table
                    :headers="headers"
                    :items="items"
                    hide-actions
                    class="elevation-1"
            >
                <template slot="items" slot-scope="props">
                    <td>
                        <v-edit-dialog
                                :return-value="props.item.totalSubscriptions"
                                lazy
                        > {{ props.item.totalSubscriptions }}
                            <v-text-field
                                    slot="input"
                                    :value="props.item.totalSubscriptions"
                                    @change="(value) => editItem(props.item.unitPrice, value)"
                                    label="Edit"
                                    single-line
                            ></v-text-field>
                        </v-edit-dialog>
                    </td>
                    <td>{{ props.item.originalTotalSubscriptions }}</td>
                    <td>{{ props.item.unitPrice }}</td>
                    <td>{{ props.item.totalPrice }}</td>
                </template>
                <template slot="no-data">
                    Geen data gevonden. <v-btn v-if="hasReport == false" color="primary" @click="generateReport(false)">Rapport maken</v-btn>
                </template>
                <template slot="footer" v-if="report && report.totals">
                    <td>
                        <strong>{{report.totals.totalSubscriptions}}</strong>
                    </td>
                    <td>
                        <strong>{{report.totals.originalTotalSubscriptions}}</strong>
                    </td>
                    <td></td>
                    <td>
                        <strong>{{report.totals.totalPrice}}</strong>
                    </td>
                </template>
            </v-data-table>
            <template>
                <v-btn v-if="hasReport == true" color="primary" @click="() => {generateReport(true)}">Reset</v-btn>
            </template>
        </v-container>
        <v-container fluid grid-list-lg>
            <iframe width="100%" height="600px" :src="reportDocument" frameborder="0"></iframe>
        </v-container>
    </v-content>
</template>

<script>
import { db } from "../../firebase";
import printReport from "../subscriptionsPrinter";

export default {
  name: "SubscriptionsReport",
  props: {
    id: String
  },
  data() {
    return {
      subscriptions: [],
      matchKey: null,
      report: {},
      reportKey: null,
      reportDocument: null,
      dialog: false,
      reportGenerated: false,
      itemToEdit: null,
      isDouble: v => !isNaN(Number(v)),
      headers: [
        {
          text: "Aantal abonnementen",
          value: "totalSubscriptions",
          sortable: false
        },
        {
          text: "Origineel aantal abonnementen",
          value: "originalTotalSubscriptions",
          sortable: false
        },
        {
          text: "Prijs per abonnement (€)",
          align: "left",
          sortable: false,
          value: "unitPrice"
        },
        { text: "Totaal (€)", value: "totalPrice", sortable: false }
      ]
    };
  },
  computed: {
    hasReport() {
      return this.reportGenerated;
    },
    items() {
      return this.hasReport ? Object.values(this.report.subscriptions) : [];
    }
  },
  mounted() {
    this.fetchReport();
  },
  firestore() {
    return {
      subscriptions: db.collection("subscriptions").orderBy("tribunePrice")
    };
  },
  methods: {
    fetchReport: function() {
      const currentYear = new Date().getFullYear();
      const nextYear = new Date().getFullYear() + 1;
      this.setReportGenerated(false);
      db.collection("subscription-reports")
        .where("year", "==", currentYear + "-" + nextYear)
        .limit(1)
        .get()
        .then(reports => {
          reports.forEach(report => {
            if (!this.hasReport) {
              this.report = report.data();
              this.reportKey = report.id;
              this.setReportGenerated(true);
            }
          });
        });
    },
    generateReportPDF: function(report) {
      this.reportDocument = printReport(report).output("datauristring");
    },
    generateReport: function(reset) {
      const currentYear = new Date().getFullYear();
      const nextYear = new Date().getFullYear() + 1;

      const report = {
        subscriptions: {},
        year: currentYear + "-" + nextYear,
        totals: {
          totalSubscriptions: 0,
          originalTotalSubscriptions: 0,
          totalPrice: 0
        }
      };

      db.collection("subscriptions")
        .get()
        .then(subscriptions => {
          // Set report tickets sold
          subscriptions.forEach(subscription => {
            const subscriptionData = subscription.data();
            const price = subscriptionData.tribunePrice || 'gratis';
            if (!report.subscriptions[price]) {
              report.subscriptions[price] = {
                unitPrice: price,
                totalSubscriptions: 0,
                originalTotalSubscriptions: 0,
                totalPrice: 0
              };
            }

            report.subscriptions[price][
              "totalSubscriptions"
            ] += 1;
            report.subscriptions[price][
              "originalTotalSubscriptions"
            ] += 1;
            report.subscriptions[price]["totalPrice"] +=
                price === "gratis"
                ? 0
                : price;
            report.totals.totalSubscriptions += 1;
            report.totals.originalTotalSubscriptions += 1;
            report.totals.totalPrice +=
                price === "gratis"
                ? 0
                : price;
          });

          // Set report general data
          if (reset) {
            if (confirm("Ben je zeker?")) {
              this.updateReport(this.reportKey, report);
              this.report = report;
            }
          } else {
            this.addReport(report);
          }
        });
    },
    setReportGenerated: function(value) {
      this.reportGenerated = value;
      if (value === true) {
        this.generateReportPDF(this.report);
      }
    },
    addReport: function(report) {
      db.collection("subscription-reports").add(report);
      this.fetchReport();
    },
    updateReport: function(reportKey, report) {
      if (reportKey) {
        db.collection("subscription-reports")
          .doc(reportKey)
          .set(report);

        this.generateReportPDF(this.report);
      }
    },
    editItem: function(price, newTotalAmount) {
      if (isNaN(Number(newTotalAmount))) {
        alert("Geen geldig totaal");
      } else {
        newTotalAmount = Number(newTotalAmount);
        const updatedReport = this.report;
        const unitPrice = updatedReport.subscriptions[price].unitPrice;
        const originalTotalSubscriptions =
          updatedReport.subscriptions[price].totalSubscriptions;
        const difference = newTotalAmount - originalTotalSubscriptions;
        const priceDifference = difference * unitPrice;
        updatedReport.subscriptions[price] = {
          ...updatedReport.subscriptions[price],
          totalSubscriptions: Number(newTotalAmount),
          totalPrice: Number(newTotalAmount) * unitPrice
        };
        updatedReport.totals.totalSubscriptions += difference;
        updatedReport.totals.totalPrice += priceDifference;
        this.updateReport(this.reportKey, updatedReport);
      }
    }
  }
};
</script>
